import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3 5.744c.02 3.19 1.386 5.51 5.547 9.514l.09.087.101.099C13.012 19.64 15.221 20.98 18.25 21c1.685 0 2.62-.716 2.737-2.378a9.85 9.85 0 0 0-.403-.308 30.553 30.553 0 0 0-1.832-1.217c-1.124-.695-2.212-1.272-2.704-1.48-.922.953-1.559 1.362-2.132 1.362-.13 0-.19-.01-.382-.065l-.066-.028c-.446-.186-1.412-.971-3.309-2.87l-.176-.176c-1.899-1.897-2.684-2.863-2.871-3.31a1.14 1.14 0 0 0-.024-.056c-.25-.683.144-1.408 1.284-2.513a6.939 6.939 0 0 0-.163-.372c-.257-.548-.662-1.281-1.138-2.066a32.783 32.783 0 0 0-1.316-2.011 10.784 10.784 0 0 0-.377-.5C3.707 3.133 2.99 4.079 3 5.745zM5.75 2c.411 0 4.166 5.895 3.671 6.346-1.64 1.505-1.387 1.798-1.387 1.798s.242.577 2.656 2.989l.176.176c2.412 2.414 2.989 2.656 2.989 2.656s.016.014.061.014c.145 0 .588-.148 1.737-1.401.027-.032.076-.045.142-.045 1.014 0 6.205 3.33 6.205 3.717 0 2.775-1.725 3.75-3.712 3.75-3.704-.023-6.288-1.953-10.25-5.843l-.198-.192C3.72 12 2.023 9.416 2 5.75 1.988 3.748 2.958 2 5.75 2z"
});

var SvgCall = function SvgCall(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCall;